import about1 from "../images/about1.jpeg";
import about2 from "../images/about2.jpeg";
import about3 from "../images/about3.jpeg";
import about4 from "../images/about4.jfif";

const AboutDetails = () => {
  const detail1 =
    "Welcome to ENOVUE.COM! We are a team of experienced and skilled professionals who are dedicated to providing top-quality solutions for UI/UX design, graphic design, content writing, SEO, digital marketing, and database infrastructure management. Our mission is to help businesses thrive in the digital world by providing innovative and effective solutions that cater to their unique needs.Our team consists of experts with diverse backgrounds and specialties, including designers, developers, writers, marketers, and database administrators. This means that we have the knowledge and expertise to create custom solutions that are tailored to your specific requirements. We understand the importance of having a strong online presence, and we are committed to helping you achieve that.";
  const detail2 =
    "At ENOVUE.COM, we prioritize quality and customer satisfaction above all else. We work closely with our clients to fully understand their needs and goals, and we strive to deliver results that exceed their expectations. We are dedicated to staying up-to-date with the latest trends and technologies, so that we can offer the most innovative and effective solutionsWhether you need help with creating a user-friendly and visually appealing website, designing eye-catching graphics and branding, developing engaging content that resonates with your audience, boosting your search engine ranking through SEO, implementing effective digital marketing strategies, or managing your databases for optimal performance, we have got you covered.We believe that every business is unique, and we take a personalized approach to our services to ensure that we meet your specific needs. Our solutions are designed to help you stand out from the competition, enhance your online presence, and achieve your business goals.";
  return (
    <div className="mt-4 px-10 py-5 min-h-[600px]">
      <div className="flex flex-col ">
        <div className="flex items-center lg:flex-row flex-col">
          <img
            className="lg:w-[350px] w-[100%] h-[300px] object-cover rounded-lg"
            src={about4}
            alt=""
            srcset=""
          />
          <p className="lg:ml-5 lg:mt-0 my-3 text-lg text-gray-600">{detail1}</p>
        </div>
        <div className="flex items-center lg:flex-row-reverse flex-col mt-3">
          <img
            className="lg:w-[350px] w-[100%] h-[300px] object-cover rounded-lg"
            src={about3}
            alt=""
          />
          <p className="lg:mr-5 lg:mt-0 mt-3 text-lg text-gray-600">{detail2}</p>
        </div>
        <p className="mt-4 text-lg text-gray-600 font-semibold text-center">
          Thank you for considering ENOVUE.COM as your solution provider. We
          look forward to working with you and helping you succeed in the
          digital world!
        </p>
      </div>
    </div>
  );
};
export default AboutDetails;
